/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SystemImport } from './routes/_system'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppImport } from './routes/_app'
import { Route as AppIndexImport } from './routes/_app/index'
import { Route as AuthLoginImport } from './routes/_auth/login'

// Create Virtual Routes

const SystemMaintenanceLazyImport = createFileRoute('/_system/maintenance')()
const SystemDeletedLazyImport = createFileRoute('/_system/deleted')()
const AppSettingsLazyImport = createFileRoute('/_app/settings')()
const AppGameLazyImport = createFileRoute('/_app/game')()
const AppFlockLazyImport = createFileRoute('/_app/flock')()
const AppPoll2PollSlugLazyImport = createFileRoute('/_app/poll2/$pollSlug')()
const AppPoll1PollSlugLazyImport = createFileRoute('/_app/poll1/$pollSlug')()
const AppPollPollSlugLazyImport = createFileRoute('/_app/poll/$pollSlug')()
const AppPoll2ZooIndexLazyImport = createFileRoute('/_app/poll2/zoo/')()
const AppPoll1ZooIndexLazyImport = createFileRoute('/_app/poll1/zoo/')()
const AppPollZooIndexLazyImport = createFileRoute('/_app/poll/zoo/')()
const AppPoll2ZooWidgetLazyImport = createFileRoute('/_app/poll2/zoo/$widget')()
const AppPoll1ZooWidgetLazyImport = createFileRoute('/_app/poll1/zoo/$widget')()
const AppPollZooWidgetLazyImport = createFileRoute('/_app/poll/zoo/$widget')()
const AppPoll2ZooWidgetRunIdLazyImport = createFileRoute(
  '/_app/poll2/zoo/$widget_/$runId',
)()

// Create/Update Routes

const SystemRoute = SystemImport.update({
  id: '/_system',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const SystemMaintenanceLazyRoute = SystemMaintenanceLazyImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => SystemRoute,
} as any).lazy(() =>
  import('./routes/_system/maintenance.lazy').then((d) => d.Route),
)

const SystemDeletedLazyRoute = SystemDeletedLazyImport.update({
  id: '/deleted',
  path: '/deleted',
  getParentRoute: () => SystemRoute,
} as any).lazy(() =>
  import('./routes/_system/deleted.lazy').then((d) => d.Route),
)

const AppSettingsLazyRoute = AppSettingsLazyImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/settings.lazy').then((d) => d.Route))

const AppGameLazyRoute = AppGameLazyImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/game.lazy').then((d) => d.Route))

const AppFlockLazyRoute = AppFlockLazyImport.update({
  id: '/flock',
  path: '/flock',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/flock.lazy').then((d) => d.Route))

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const AppPoll2PollSlugLazyRoute = AppPoll2PollSlugLazyImport.update({
  id: '/poll2/$pollSlug',
  path: '/poll2/$pollSlug',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll2.$pollSlug.lazy').then((d) => d.Route),
)

const AppPoll1PollSlugLazyRoute = AppPoll1PollSlugLazyImport.update({
  id: '/poll1/$pollSlug',
  path: '/poll1/$pollSlug',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll1.$pollSlug.lazy').then((d) => d.Route),
)

const AppPollPollSlugLazyRoute = AppPollPollSlugLazyImport.update({
  id: '/poll/$pollSlug',
  path: '/poll/$pollSlug',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll.$pollSlug.lazy').then((d) => d.Route),
)

const AppPoll2ZooIndexLazyRoute = AppPoll2ZooIndexLazyImport.update({
  id: '/poll2/zoo/',
  path: '/poll2/zoo/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll2.zoo.index.lazy').then((d) => d.Route),
)

const AppPoll1ZooIndexLazyRoute = AppPoll1ZooIndexLazyImport.update({
  id: '/poll1/zoo/',
  path: '/poll1/zoo/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll1.zoo.index.lazy').then((d) => d.Route),
)

const AppPollZooIndexLazyRoute = AppPollZooIndexLazyImport.update({
  id: '/poll/zoo/',
  path: '/poll/zoo/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll.zoo.index.lazy').then((d) => d.Route),
)

const AppPoll2ZooWidgetLazyRoute = AppPoll2ZooWidgetLazyImport.update({
  id: '/poll2/zoo/$widget',
  path: '/poll2/zoo/$widget',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll2.zoo.$widget.lazy').then((d) => d.Route),
)

const AppPoll1ZooWidgetLazyRoute = AppPoll1ZooWidgetLazyImport.update({
  id: '/poll1/zoo/$widget',
  path: '/poll1/zoo/$widget',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll1.zoo.$widget.lazy').then((d) => d.Route),
)

const AppPollZooWidgetLazyRoute = AppPollZooWidgetLazyImport.update({
  id: '/poll/zoo/$widget',
  path: '/poll/zoo/$widget',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/poll.zoo.$widget.lazy').then((d) => d.Route),
)

const AppPoll2ZooWidgetRunIdLazyRoute = AppPoll2ZooWidgetRunIdLazyImport.update(
  {
    id: '/poll2/zoo/$widget_/$runId',
    path: '/poll2/zoo/$widget/$runId',
    getParentRoute: () => AppRoute,
  } as any,
).lazy(() =>
  import('./routes/_app/poll2.zoo.$widget_.$runId.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_system': {
      id: '/_system'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SystemImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_app/flock': {
      id: '/_app/flock'
      path: '/flock'
      fullPath: '/flock'
      preLoaderRoute: typeof AppFlockLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/game': {
      id: '/_app/game'
      path: '/game'
      fullPath: '/game'
      preLoaderRoute: typeof AppGameLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsLazyImport
      parentRoute: typeof AppImport
    }
    '/_system/deleted': {
      id: '/_system/deleted'
      path: '/deleted'
      fullPath: '/deleted'
      preLoaderRoute: typeof SystemDeletedLazyImport
      parentRoute: typeof SystemImport
    }
    '/_system/maintenance': {
      id: '/_system/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof SystemMaintenanceLazyImport
      parentRoute: typeof SystemImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/poll/$pollSlug': {
      id: '/_app/poll/$pollSlug'
      path: '/poll/$pollSlug'
      fullPath: '/poll/$pollSlug'
      preLoaderRoute: typeof AppPollPollSlugLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll1/$pollSlug': {
      id: '/_app/poll1/$pollSlug'
      path: '/poll1/$pollSlug'
      fullPath: '/poll1/$pollSlug'
      preLoaderRoute: typeof AppPoll1PollSlugLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll2/$pollSlug': {
      id: '/_app/poll2/$pollSlug'
      path: '/poll2/$pollSlug'
      fullPath: '/poll2/$pollSlug'
      preLoaderRoute: typeof AppPoll2PollSlugLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll/zoo/$widget': {
      id: '/_app/poll/zoo/$widget'
      path: '/poll/zoo/$widget'
      fullPath: '/poll/zoo/$widget'
      preLoaderRoute: typeof AppPollZooWidgetLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll1/zoo/$widget': {
      id: '/_app/poll1/zoo/$widget'
      path: '/poll1/zoo/$widget'
      fullPath: '/poll1/zoo/$widget'
      preLoaderRoute: typeof AppPoll1ZooWidgetLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll2/zoo/$widget': {
      id: '/_app/poll2/zoo/$widget'
      path: '/poll2/zoo/$widget'
      fullPath: '/poll2/zoo/$widget'
      preLoaderRoute: typeof AppPoll2ZooWidgetLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll/zoo/': {
      id: '/_app/poll/zoo/'
      path: '/poll/zoo'
      fullPath: '/poll/zoo'
      preLoaderRoute: typeof AppPollZooIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll1/zoo/': {
      id: '/_app/poll1/zoo/'
      path: '/poll1/zoo'
      fullPath: '/poll1/zoo'
      preLoaderRoute: typeof AppPoll1ZooIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll2/zoo/': {
      id: '/_app/poll2/zoo/'
      path: '/poll2/zoo'
      fullPath: '/poll2/zoo'
      preLoaderRoute: typeof AppPoll2ZooIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/poll2/zoo/$widget_/$runId': {
      id: '/_app/poll2/zoo/$widget_/$runId'
      path: '/poll2/zoo/$widget/$runId'
      fullPath: '/poll2/zoo/$widget/$runId'
      preLoaderRoute: typeof AppPoll2ZooWidgetRunIdLazyImport
      parentRoute: typeof AppImport
    }
  }
}

// Create and export the route tree

interface AppRouteChildren {
  AppFlockLazyRoute: typeof AppFlockLazyRoute
  AppGameLazyRoute: typeof AppGameLazyRoute
  AppSettingsLazyRoute: typeof AppSettingsLazyRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPollPollSlugLazyRoute: typeof AppPollPollSlugLazyRoute
  AppPoll1PollSlugLazyRoute: typeof AppPoll1PollSlugLazyRoute
  AppPoll2PollSlugLazyRoute: typeof AppPoll2PollSlugLazyRoute
  AppPollZooWidgetLazyRoute: typeof AppPollZooWidgetLazyRoute
  AppPoll1ZooWidgetLazyRoute: typeof AppPoll1ZooWidgetLazyRoute
  AppPoll2ZooWidgetLazyRoute: typeof AppPoll2ZooWidgetLazyRoute
  AppPollZooIndexLazyRoute: typeof AppPollZooIndexLazyRoute
  AppPoll1ZooIndexLazyRoute: typeof AppPoll1ZooIndexLazyRoute
  AppPoll2ZooIndexLazyRoute: typeof AppPoll2ZooIndexLazyRoute
  AppPoll2ZooWidgetRunIdLazyRoute: typeof AppPoll2ZooWidgetRunIdLazyRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppFlockLazyRoute: AppFlockLazyRoute,
  AppGameLazyRoute: AppGameLazyRoute,
  AppSettingsLazyRoute: AppSettingsLazyRoute,
  AppIndexRoute: AppIndexRoute,
  AppPollPollSlugLazyRoute: AppPollPollSlugLazyRoute,
  AppPoll1PollSlugLazyRoute: AppPoll1PollSlugLazyRoute,
  AppPoll2PollSlugLazyRoute: AppPoll2PollSlugLazyRoute,
  AppPollZooWidgetLazyRoute: AppPollZooWidgetLazyRoute,
  AppPoll1ZooWidgetLazyRoute: AppPoll1ZooWidgetLazyRoute,
  AppPoll2ZooWidgetLazyRoute: AppPoll2ZooWidgetLazyRoute,
  AppPollZooIndexLazyRoute: AppPollZooIndexLazyRoute,
  AppPoll1ZooIndexLazyRoute: AppPoll1ZooIndexLazyRoute,
  AppPoll2ZooIndexLazyRoute: AppPoll2ZooIndexLazyRoute,
  AppPoll2ZooWidgetRunIdLazyRoute: AppPoll2ZooWidgetRunIdLazyRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface SystemRouteChildren {
  SystemDeletedLazyRoute: typeof SystemDeletedLazyRoute
  SystemMaintenanceLazyRoute: typeof SystemMaintenanceLazyRoute
}

const SystemRouteChildren: SystemRouteChildren = {
  SystemDeletedLazyRoute: SystemDeletedLazyRoute,
  SystemMaintenanceLazyRoute: SystemMaintenanceLazyRoute,
}

const SystemRouteWithChildren =
  SystemRoute._addFileChildren(SystemRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof SystemRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/flock': typeof AppFlockLazyRoute
  '/game': typeof AppGameLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/deleted': typeof SystemDeletedLazyRoute
  '/maintenance': typeof SystemMaintenanceLazyRoute
  '/': typeof AppIndexRoute
  '/poll/$pollSlug': typeof AppPollPollSlugLazyRoute
  '/poll1/$pollSlug': typeof AppPoll1PollSlugLazyRoute
  '/poll2/$pollSlug': typeof AppPoll2PollSlugLazyRoute
  '/poll/zoo/$widget': typeof AppPollZooWidgetLazyRoute
  '/poll1/zoo/$widget': typeof AppPoll1ZooWidgetLazyRoute
  '/poll2/zoo/$widget': typeof AppPoll2ZooWidgetLazyRoute
  '/poll/zoo': typeof AppPollZooIndexLazyRoute
  '/poll1/zoo': typeof AppPoll1ZooIndexLazyRoute
  '/poll2/zoo': typeof AppPoll2ZooIndexLazyRoute
  '/poll2/zoo/$widget/$runId': typeof AppPoll2ZooWidgetRunIdLazyRoute
}

export interface FileRoutesByTo {
  '': typeof SystemRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/flock': typeof AppFlockLazyRoute
  '/game': typeof AppGameLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/deleted': typeof SystemDeletedLazyRoute
  '/maintenance': typeof SystemMaintenanceLazyRoute
  '/': typeof AppIndexRoute
  '/poll/$pollSlug': typeof AppPollPollSlugLazyRoute
  '/poll1/$pollSlug': typeof AppPoll1PollSlugLazyRoute
  '/poll2/$pollSlug': typeof AppPoll2PollSlugLazyRoute
  '/poll/zoo/$widget': typeof AppPollZooWidgetLazyRoute
  '/poll1/zoo/$widget': typeof AppPoll1ZooWidgetLazyRoute
  '/poll2/zoo/$widget': typeof AppPoll2ZooWidgetLazyRoute
  '/poll/zoo': typeof AppPollZooIndexLazyRoute
  '/poll1/zoo': typeof AppPoll1ZooIndexLazyRoute
  '/poll2/zoo': typeof AppPoll2ZooIndexLazyRoute
  '/poll2/zoo/$widget/$runId': typeof AppPoll2ZooWidgetRunIdLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_system': typeof SystemRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_app/flock': typeof AppFlockLazyRoute
  '/_app/game': typeof AppGameLazyRoute
  '/_app/settings': typeof AppSettingsLazyRoute
  '/_system/deleted': typeof SystemDeletedLazyRoute
  '/_system/maintenance': typeof SystemMaintenanceLazyRoute
  '/_app/': typeof AppIndexRoute
  '/_app/poll/$pollSlug': typeof AppPollPollSlugLazyRoute
  '/_app/poll1/$pollSlug': typeof AppPoll1PollSlugLazyRoute
  '/_app/poll2/$pollSlug': typeof AppPoll2PollSlugLazyRoute
  '/_app/poll/zoo/$widget': typeof AppPollZooWidgetLazyRoute
  '/_app/poll1/zoo/$widget': typeof AppPoll1ZooWidgetLazyRoute
  '/_app/poll2/zoo/$widget': typeof AppPoll2ZooWidgetLazyRoute
  '/_app/poll/zoo/': typeof AppPollZooIndexLazyRoute
  '/_app/poll1/zoo/': typeof AppPoll1ZooIndexLazyRoute
  '/_app/poll2/zoo/': typeof AppPoll2ZooIndexLazyRoute
  '/_app/poll2/zoo/$widget_/$runId': typeof AppPoll2ZooWidgetRunIdLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/flock'
    | '/game'
    | '/settings'
    | '/deleted'
    | '/maintenance'
    | '/'
    | '/poll/$pollSlug'
    | '/poll1/$pollSlug'
    | '/poll2/$pollSlug'
    | '/poll/zoo/$widget'
    | '/poll1/zoo/$widget'
    | '/poll2/zoo/$widget'
    | '/poll/zoo'
    | '/poll1/zoo'
    | '/poll2/zoo'
    | '/poll2/zoo/$widget/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/login'
    | '/flock'
    | '/game'
    | '/settings'
    | '/deleted'
    | '/maintenance'
    | '/'
    | '/poll/$pollSlug'
    | '/poll1/$pollSlug'
    | '/poll2/$pollSlug'
    | '/poll/zoo/$widget'
    | '/poll1/zoo/$widget'
    | '/poll2/zoo/$widget'
    | '/poll/zoo'
    | '/poll1/zoo'
    | '/poll2/zoo'
    | '/poll2/zoo/$widget/$runId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_system'
    | '/_auth/login'
    | '/_app/flock'
    | '/_app/game'
    | '/_app/settings'
    | '/_system/deleted'
    | '/_system/maintenance'
    | '/_app/'
    | '/_app/poll/$pollSlug'
    | '/_app/poll1/$pollSlug'
    | '/_app/poll2/$pollSlug'
    | '/_app/poll/zoo/$widget'
    | '/_app/poll1/zoo/$widget'
    | '/_app/poll2/zoo/$widget'
    | '/_app/poll/zoo/'
    | '/_app/poll1/zoo/'
    | '/_app/poll2/zoo/'
    | '/_app/poll2/zoo/$widget_/$runId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  SystemRoute: typeof SystemRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  SystemRoute: SystemRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/_auth",
        "/_system"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/flock",
        "/_app/game",
        "/_app/settings",
        "/_app/",
        "/_app/poll/$pollSlug",
        "/_app/poll1/$pollSlug",
        "/_app/poll2/$pollSlug",
        "/_app/poll/zoo/$widget",
        "/_app/poll1/zoo/$widget",
        "/_app/poll2/zoo/$widget",
        "/_app/poll/zoo/",
        "/_app/poll1/zoo/",
        "/_app/poll2/zoo/",
        "/_app/poll2/zoo/$widget_/$runId"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login"
      ]
    },
    "/_system": {
      "filePath": "_system.tsx",
      "children": [
        "/_system/deleted",
        "/_system/maintenance"
      ]
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_app/flock": {
      "filePath": "_app/flock.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/game": {
      "filePath": "_app/game.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/settings": {
      "filePath": "_app/settings.lazy.tsx",
      "parent": "/_app"
    },
    "/_system/deleted": {
      "filePath": "_system/deleted.lazy.tsx",
      "parent": "/_system"
    },
    "/_system/maintenance": {
      "filePath": "_system/maintenance.lazy.tsx",
      "parent": "/_system"
    },
    "/_app/": {
      "filePath": "_app/index.tsx",
      "parent": "/_app"
    },
    "/_app/poll/$pollSlug": {
      "filePath": "_app/poll.$pollSlug.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll1/$pollSlug": {
      "filePath": "_app/poll1.$pollSlug.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll2/$pollSlug": {
      "filePath": "_app/poll2.$pollSlug.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll/zoo/$widget": {
      "filePath": "_app/poll.zoo.$widget.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll1/zoo/$widget": {
      "filePath": "_app/poll1.zoo.$widget.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll2/zoo/$widget": {
      "filePath": "_app/poll2.zoo.$widget.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll/zoo/": {
      "filePath": "_app/poll.zoo.index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll1/zoo/": {
      "filePath": "_app/poll1.zoo.index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll2/zoo/": {
      "filePath": "_app/poll2.zoo.index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/poll2/zoo/$widget_/$runId": {
      "filePath": "_app/poll2.zoo.$widget_.$runId.lazy.tsx",
      "parent": "/_app"
    }
  }
}
ROUTE_MANIFEST_END */
